// TierSelect.jsx
import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const TierSelect = ({ value, onChange, label = "Select Tier", ...props }) => {
  const tiers = [
    { option: "Basic", value: 1 },
    { option: "Advanced", value: 2 },
    { option: "Premium", value: 3 },
  ];

  return (
    <FormControl fullWidth {...props}>
      <InputLabel>{label}</InputLabel>
      <Select value={value} onChange={onChange} label={label}>
        {tiers.map((tier) => (
          <MenuItem key={tier.value} value={tier.value}>
            {tier.option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TierSelect;